
define('text!modules/audiences/onboarding/create/templates/otherEvent/advertisers.html',[],function () { return '<div class="col-1-4">\n  <strand-header size="small">Advertiser</strand-header>\n  <strand-dropdown id="advertisers" fitparent name="dropdown" placeholder="Select One">\n    <strand-input search clear placeholder="Search"></strand-input>\n  </strand-dropdown>\n</div>\n';});

